export class ProvinceInput {
    public name: string = '';
    public countryId: number = 0;
}
